export default {
  admin: [
    {
      icon: 'fa fa-chart-line',
      label: '數據分析',
      group: [
        {
          label: 'admin.report.member-trend',
          route: {
            name: 'admin.report.member-trend',
          },
          roles: ['ROLE_ADMIN', 'ROLE_REPORT'],
        },
        {
          label: 'admin.report.audience',
          route: {
            name: 'admin.report.audience',
          },
          roles: ['ROLE_ADMIN', 'ROLE_REPORT'],
        },
        {
          label: 'admin.report.member',
          route: {
            name: 'admin.report.member',
            params: { scope: 'daily' },
          },
          roles: ['ROLE_MAINTAINER', 'ROLE_REPORT'],
        },
        {
          label: 'admin.report.video',
          route: {
            name: 'admin.report.video',
            params: { scope: 'daily' },
          },
          roles: ['ROLE_ADMIN', 'ROLE_REPORT'],
        },
        {
          label: 'admin.report.pageview',
          route: {
            name: 'admin.report.pageview',
            params: { scope: 'daily' },
          },
          roles: ['ROLE_ADMIN', 'ROLE_REPORT'],
        },
        {
          label: 'admin.report.keywords',
          route: {
            name: 'admin.report.keywords',
            params: { scope: 'daily' },
          },
          roles: ['ROLE_ADMIN', 'ROLE_REPORT'],
        },
        {
          label: 'admin.report.memberGA4',
          route: {
            name: 'admin.report.memberGA4',
            params: { scope: 'daily' },
          },
          roles: ['ROLE_ADMIN', 'ROLE_REPORT'],
        },
        {
          label: 'admin.report.videoGA4',
          route: {
            name: 'admin.report.videoGA4',
            params: { scope: 'scope' },
          },
          roles: ['ROLE_ADMIN', 'ROLE_REPORT'],
        },
        {
          label: 'admin.report.pageviewGA4',
          route: {
            name: 'admin.report.pageviewGA4',
            params: { scope: 'scope' },
          },
          roles: ['ROLE_ADMIN', 'ROLE_REPORT'],
        },
        {
          label: 'admin.report.keywordsGA4',
          route: {
            name: 'admin.report.keywordsGA4',
            params: { scope: 'scope' },
          },
          roles: ['ROLE_ADMIN', 'ROLE_REPORT'],
        },
      ],
    },


  ],
}